
import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ProxyConfigErrorProps {
  error: string;
  onRetry: () => void;
  loading?: boolean;
}

export const ProxyConfigError: React.FC<ProxyConfigErrorProps> = ({ 
  error, 
  onRetry, 
  loading = false 
}) => {
  return (
    <Alert variant="destructive" className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription className="flex items-center justify-between">
        <div>
          <p className="font-medium">Проблема с загрузкой конфигурации прокси</p>
          <p className="text-sm mt-1">{error}</p>
          <p className="text-xs mt-2 opacity-75">
            Используется резервная конфигурация. Функциональность может быть ограничена.
          </p>
        </div>
        <Button
          onClick={onRetry}
          disabled={loading}
          variant="outline"
          size="sm"
          className="ml-4 shrink-0"
        >
          {loading ? (
            <RefreshCw className="h-4 w-4 animate-spin" />
          ) : (
            <RefreshCw className="h-4 w-4" />
          )}
        </Button>
      </AlertDescription>
    </Alert>
  );
};
